<template>
  <div class="transferConfirmSuccess bgwhite">
    <div class="paySuccess">
      <div class="paySuccessImg">
        <img src="../../assets/wxRenew/pay-success.gif">
      </div>
      <div class="transferConfirmSuccess-success-msg">接收成功</div>
      <div class="paySuccessText">
        <div>物品清单中已勾选的客户物品</div>
        <div>已从移交人转移到您名下持有</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Icon } from "vant";
Vue.use(Row)
  .use(Col)
  .use(Icon)

export default {
  name: "interiorConfirmNewsSuccess",
  components: {},
  data() {
    return {

    };
  },

  methods: {
    init() {
    },
    timerFun() {

    }
  },
  mounted: function() {
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    this.init();
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.transferConfirmSuccess.bgwhite{
  background-color #ffffff;
  height  100%;
  padding-bottom 0;
}
.transferConfirmSuccess {
  position: relative;
  padding-bottom 0.5rem

  .paySuccess {
    text-align center
    .paySuccessImg{
      padding-top: 1.68rem;
      img{
        width 0.88rem
      }
    }
    .transferConfirmSuccess-success-msg{
      font-size: 0.24rem;
      margin-top: 0.08rem;
      font-weight: bold;
      color #1A2633
    }
    .paySuccessText {
      margin-top: 0.12rem;
      text-align: center;
      color #414F5E
    }
    .paySuccessText-time {
      font-size: 0.16rem;
    }
  }
}
</style>
